<template>
  <div>
    <div v-if="isNotFound" class="wrapper">
      「{{ keyword }}」に一致する結果が見つかりませんでした。
    </div>
    <div v-else-if="searchResultList.length" class="wrapper">
      <template v-for="(item, index) in searchResultList">
        <AutoCompleteItem
          :key="item.description"
          :item="item"
          :isSelected="currentSearchResultIndex === index"
        />
      </template>
    </div>
  </div>
</template>

<script>
import AutoCompleteItem from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/Map/serach/AutoCompleteItem'

export default {
  name: 'AutoCompleteList',
  components: { AutoCompleteItem },
  props: {
    searchResultList: Array,
    currentSearchResultIndex: Number,
    keyword: String,
    isNotFound: Boolean,
  },
}
</script>

<style scoped lang="scss">
.wrapper {
  padding: 5px 0;
}
</style>
